import { AiOutlineOrderedList } from "react-icons/ai";
import { ImUsers } from "react-icons/im";
import { RiErrorWarningFill } from "react-icons/ri";
import style from "./style.module.scss";
import { UserRole } from "../../../constants/enum/UserRole";
import { useNavigate } from "react-router-dom";

export default function SummaryAdminSection() {
  // 1
  let widgets:any=[]
  const navigate = useNavigate();

  const provas_nao_corrigidas = 10;
  const correcao_fora_do_prazo = 2;
  const questionarios_sem_respostas = 3;

  // 2
  const total_demandas = 293;
  const nao_fizeram_prova = 10;

  
  return (
    <div
      style={{
        width: "100%",
        height: "max-content",
        display: "flex",
        flexDirection: "column",
      }}
    >
     
    </div>
  );
}
